import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap';
import {AuthService} from '../../core/auth/auth.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-update-plan',
  templateUrl: './update-plan.component.html',
  styleUrls: ['./update-plan.component.scss']
})
export class UpdatePlanComponent implements OnInit {

  @ViewChild('planTemplate') planTemplate: TemplateRef<any>;

  modalRef: BsModalRef;

  constructor(private router: Router, private authService: AuthService) { }

  ngOnInit() {
  }

  logout(e) {
    this.authService.logout();
    this.router.navigate(['/login']);
    e.preventDefault();
  }

  close(e) {
    this.router.navigate(['/']);
  }

}



// WEBPACK FOOTER //
// ./client/app/components/update-plan/update-plan.component.ts